import React from "react";

import { EsgEmissionSummaryIcon } from "assets";

export const SITES_EMISSIONS_PAGE = {
  ABSOLUTE_PATH: "/sites-emissions",
  TITLE: "Emissions Overview",
  ICON: <EsgEmissionSummaryIcon />,
  IS_TBD: false,
  renderMenu: false,
};
